import axios from "axios";

const baseUrl = "/AutoConnectSSO/api/Authentication/Shared/Authentication";

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function authenticateEmail(
  flowName: string,
  login: string,
  password: string,
  email: string
) {
  const url = `/ByEmailLoginPassword/${flowName}`;
  const response = await instance.post<void>(url, {
    login,
    password,
    email
  });
  return response.data;
}

async function authenticateNationalId(
  flowName: string,
  login: string,
  password: string,
  nationalId: string
) {
  const url = `/ByNationalIdLoginPassword/${flowName}`;
  const response = await instance.post<void>(url, {
    login,
    password,
    nationalId
  });
  return response.data;
}

export const AuthenticationService = {
  authenticateEmail,
  authenticateNationalId
};
